<div class="content">
  <div class="nav-header" *ngIf="isMyCvDetail">
    <span class="header-title">Mein Profil</span>
    <div class="nav-button-group">
      <button mat-button routerLink="/cv-detail/de" routerLinkActive="link-active">
        Mein Profil in Deutsch
      </button>
      <button mat-button routerLink="/cv-detail/en" routerLinkActive="link-active">
        Profile in English
      </button>
    </div>
  </div>
  <div [ngClass]="{'cv-detail': cv.cvTempFileName}">
    <!-- <div > -->
      <app-cv-data [cv]="cv" (cvChangeHandler)="handleCVChange($event)"
        (cvDirtyHandler)="markAsDirty($event)">
      </app-cv-data>
    <!-- </div> -->
    <!-- <div class="file" *ngIf="cv && cv.cvTempFileName">
      <app-cv-file [fileUrl]="cv.cvTempFileName"></app-cv-file>
    </div> -->
  </div>
</div>
